import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=0948ca58&"
import script from "./TemplateModal.vue?vue&type=script&lang=js&"
export * from "./TemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&id=0948ca58&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports